// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-group {
}

.button-group-title {
    font-family: sans-serif;
    text-align: center;
    padding: 5px;
    border-bottom: 1px solid #938e8e;
}

.button-group .button-plugin-container {
    display: inline;
}

.button-group .button-plugin-wrapper {
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
	box-sizing: border-box;
}

.button-group .button-plugin-container button {
	width: 40px;
	height: 40px;
	display: block;
	background: none;
	border: none;
	float: left;
}

.button-group button:hover {
	background-color: var(--secondary-bg-color-hover);
}

.button-group button:active {
	background-color: var(--main-bg-color);
}

.button-group button i {
	background-size: 50% 50%;
	width: 20px;
	height: 20px;
	display: block;
	background-repeat: no-repeat;
	background-position: 3px 7px;
	margin-left: 5px;
}

/* Fix default iPad button padding */
.button-group .button-plugin-container button {
	padding: 2px 6px 3px 6px;
}

.video-container .button-plugin-container button {
	padding: 2px 6px 3px 6px;
}

.button-group span.button-title {
    display: block;
}

.button-group span.button-title.button-title-small {
	margin-top: -16px;
    font-size: 8px;
}

.button-group span.button-title.button-title-medium {
	margin-top: -17px;
    font-size: 10px;
}

.button-group span.button-title.button-title-large {
	margin-top: -19px;
    font-size: 12px;
}

.button-group span.button-title:empty {
	margin-top: 0 !important;
}

.button-group button.dynamic-width span {
    margin-top: 0px;
    color: var(--main-fg-color);
    padding-left: 3px;
    padding-right: 3px;
}

.button-group button.dynamic-width span.button-title-small {
    margin-top: 0px;
}

.button-group button.dynamic-width span.button-title-medium {
    margin-top: 0px;
}

.button-group button.dynamic-width span.button-title-large {
    margin-top: 0px;
}


.button-group button i svg {
	width: 100%;
    height: 100%;
    fill: var(--main-fg-color);
	color: var(--main-fg-color);
}

.button-group .button-plugin-wrapper .button-description {
    font-family: sans-serif;
    margin-left: 4px;
	cursor: pointer;
	height: 40px;
	line-height: 40px;
	padding-right: 20px;
	box-sizing: border-box;
	color: var(--main-fg-color);
	user-select: none;
}

.button-group .button-plugin-wrapper .button-description:hover {
    color: var(--main-fg-color);
	text-shadow:0px 0px 2px var(--main-fg-color);
}`, "",{"version":3,"sources":["webpack://./src/css/ButtonGroup.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;CACtB,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,gBAAgB;CAChB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,wBAAwB;CACxB,WAAW;CACX,YAAY;CACZ,cAAc;CACd,4BAA4B;CAC5B,4BAA4B;CAC5B,gBAAgB;AACjB;;AAEA,oCAAoC;AACpC;CACC,wBAAwB;AACzB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;CACC,iBAAiB;IACd,cAAc;AAClB;;AAEA;CACC,iBAAiB;IACd,eAAe;AACnB;;AAEA;CACC,iBAAiB;IACd,eAAe;AACnB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;;AAGA;CACC,WAAW;IACR,YAAY;IACZ,0BAA0B;CAC7B,2BAA2B;AAC5B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;CACnB,eAAe;CACf,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;CACnB,sBAAsB;CACtB,2BAA2B;CAC3B,iBAAiB;AAClB;;AAEA;IACI,2BAA2B;CAC9B,4CAA4C;AAC7C","sourcesContent":[".button-group {\n}\n\n.button-group-title {\n    font-family: sans-serif;\n    text-align: center;\n    padding: 5px;\n    border-bottom: 1px solid #938e8e;\n}\n\n.button-group .button-plugin-container {\n    display: inline;\n}\n\n.button-group .button-plugin-wrapper {\n    display: flex;\n    flex-direction: row;\n    align-content: center;\n    align-items: center;\n\tbox-sizing: border-box;\n}\n\n.button-group .button-plugin-container button {\n\twidth: 40px;\n\theight: 40px;\n\tdisplay: block;\n\tbackground: none;\n\tborder: none;\n\tfloat: left;\n}\n\n.button-group button:hover {\n\tbackground-color: var(--secondary-bg-color-hover);\n}\n\n.button-group button:active {\n\tbackground-color: var(--main-bg-color);\n}\n\n.button-group button i {\n\tbackground-size: 50% 50%;\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: block;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 3px 7px;\n\tmargin-left: 5px;\n}\n\n/* Fix default iPad button padding */\n.button-group .button-plugin-container button {\n\tpadding: 2px 6px 3px 6px;\n}\n\n.video-container .button-plugin-container button {\n\tpadding: 2px 6px 3px 6px;\n}\n\n.button-group span.button-title {\n    display: block;\n}\n\n.button-group span.button-title.button-title-small {\n\tmargin-top: -16px;\n    font-size: 8px;\n}\n\n.button-group span.button-title.button-title-medium {\n\tmargin-top: -17px;\n    font-size: 10px;\n}\n\n.button-group span.button-title.button-title-large {\n\tmargin-top: -19px;\n    font-size: 12px;\n}\n\n.button-group span.button-title:empty {\n\tmargin-top: 0 !important;\n}\n\n.button-group button.dynamic-width span {\n    margin-top: 0px;\n    color: var(--main-fg-color);\n    padding-left: 3px;\n    padding-right: 3px;\n}\n\n.button-group button.dynamic-width span.button-title-small {\n    margin-top: 0px;\n}\n\n.button-group button.dynamic-width span.button-title-medium {\n    margin-top: 0px;\n}\n\n.button-group button.dynamic-width span.button-title-large {\n    margin-top: 0px;\n}\n\n\n.button-group button i svg {\n\twidth: 100%;\n    height: 100%;\n    fill: var(--main-fg-color);\n\tcolor: var(--main-fg-color);\n}\n\n.button-group .button-plugin-wrapper .button-description {\n    font-family: sans-serif;\n    margin-left: 4px;\n\tcursor: pointer;\n\theight: 40px;\n\tline-height: 40px;\n\tpadding-right: 20px;\n\tbox-sizing: border-box;\n\tcolor: var(--main-fg-color);\n\tuser-select: none;\n}\n\n.button-group .button-plugin-wrapper .button-description:hover {\n    color: var(--main-fg-color);\n\ttext-shadow:0px 0px 2px var(--main-fg-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
